import React,{useState,useEffect,useCallback,useRef}from'react';
import{useNavigate}from'react-router-dom';
import Layout from'../components/layout/Layout';
import DataTable from'../components/common/DataTable';
import StatCard from'../components/common/StatCard';
import SlidePanel from'../components/common/SlidePanel';
import EntityLookup from'../components/crm/EntityLookup';
import api from'../services/api';

const ENQ=['OPD','HEALTH_PACKAGE','IPD','DIAGNOSTICS','SURGERY','CORPORATE','INSURANCE','EMERGENCY'];
const SRC=['WALK_IN','PHONE','WHATSAPP','WEBSITE','REFERRAL_DOCTOR','HEALTH_CAMP','CORPORATE','INSURANCE_TPA','OTHER'];
const ST=['NEW','CONTACTED','FOLLOW_UP','APPOINTMENT_BOOKED','EXISTING_PATIENT','CONVERTED','NO_SHOW','LOST'];
const PRI=['ROUTINE','URGENT'];
const ACCT=['INDIVIDUAL','CORPORATE','INSURANCE'];
const PIPE=[
  {key:'NEW',title:'New',statuses:['NEW']},
  {key:'PROGRESS',title:'In progress',statuses:['CONTACTED','FOLLOW_UP','EXISTING_PATIENT']},
  {key:'APPT',title:'Appointment',statuses:['APPOINTMENT_BOOKED']},
  {key:'WON',title:'Converted',statuses:['CONVERTED']},
  {key:'CLOSED',title:'Lost / No-show',statuses:['LOST','NO_SHOW']},
];
const EMPTY={
  crmId:'',firstName:'',lastName:'',phone:'',email:'',gender:'',age:'',city:'',address:'',
  enquiryType:'OPD',department:'',preferredDoctor:'',preferredDate:'',interestedService:'',
  source:'WALK_IN',referringDoctor:'',referringHospital:'',priority:'ROUTINE',nextFollowupAt:'',notes:'',
  accountType:'INDIVIDUAL',campaign:'',estimatedValue:'',corporateName:'',
  assignedTo:'',assignedEmployeeName:'',doctorId:'',existingPatientId:'',
};

function ageFromDob(dob?:string){
  if(!dob) return '';
  const n=Math.floor((Date.now()-new Date(dob).getTime())/(365.25*24*3600*1000));
  return n>0&&n<120?String(n):'';
}
function inr(n:any){
  const v=Number(n||0);
  if(!v) return '₹0';
  return '₹'+v.toLocaleString('en-IN');
}

export default function CrmPage(){
  const nav=useNavigate();
  const canRegister=true;
  const canBook=true;
  const [tab,setTab]=useState<'enquiries'|'pipeline'|'followups'>('enquiries');
  const [leads,setLeads]=useState<any[]>([]);
  const [followups,setFollowups]=useState<any[]>([]);
  const [stats,setStats]=useState<any>({});
  const [loading,setLoading]=useState(true);
  const [saving,setSaving]=useState(false);
  const [msg,setMsg]=useState('');
  const [form,setForm]=useState({...EMPTY});
  const [picked,setPicked]=useState<{patient?:any;doctor?:any;employee?:any;corporate?:any;referrer?:any}>({});
  const [statusFilter,setStatusFilter]=useState('');
  const [mine,setMine]=useState(false);
  const [dup,setDup]=useState<any[]>([]);
  const [sel,setSel]=useState<any>(null);
  const [note,setNote]=useState({type:'CALL',notes:'',nextFollowupAt:''});
  const [lostReason,setLostReason]=useState('');
  const phoneMatchRef=useRef('');
  const notify=(m:string)=>{setMsg(m);setTimeout(()=>setMsg(''),4000);};
  const f=(k:string,v:any)=>setForm(x=>({...x,[k]:v}));
  const name=(r:any)=>`${r.firstName||r.first_name||''} ${r.lastName||r.last_name||''}`.trim();
  const crmIdOf=(r:any)=>r.crmId||r.crm_id||r.lead_number;
  const phoneOf=(r:any)=>r.phone||r.mobile||'';
  const nextFu=(r:any)=>(r.nextFollowupAt||r.next_followup_at||'').toString().slice(0,10);
  const fillPatient=(p:any)=>{
    setPicked(x=>({...x,patient:p}));
    setForm(s=>({...s,
      firstName:p.first_name||p.firstName||s.firstName,
      lastName:p.last_name||p.lastName||s.lastName,
      phone:p.phone||p.mobile||s.phone,
      email:p.email||s.email,
      gender:p.gender||s.gender,
      age:ageFromDob(p.date_of_birth||p.dateOfBirth)||s.age,
      city:p.city||s.city,
      crmId:p.crm_id||p.crmId||s.crmId,
      existingPatientId:p.id,
    }));
  };

  const load=useCallback(async()=>{
    setLoading(true);
    try{
      const[list,st,today,overdue]=await Promise.all([
        api.getCrmLeads({status:statusFilter||undefined,mine:mine||undefined,take:200}).catch(()=>({data:{leads:[]}})),
        api.getCrmStats().catch(()=>({data:{}})),
        api.getCrmFollowupsToday().catch(()=>({data:[]})),
        api.getCrmFollowupsOverdue().catch(()=>({data:[]})),
      ]);
      const rows=list?.data?.leads||list?.data?.data||list?.data||[];
      setLeads(Array.isArray(rows)?rows:[]);
      setStats(st?.data||{});
      const t=Array.isArray(today?.data)?today.data:today?.data?.leads||[];
      const o=Array.isArray(overdue?.data)?overdue.data:overdue?.data?.leads||[];
      setFollowups([...o.map((x:any)=>({...x,overdue:true})),...t]);
    }catch{}
    setLoading(false);
  },[statusFilter,mine]);

  useEffect(()=>{load();},[load]);

  useEffect(()=>{
    const digits=(form.phone||'').replace(/\D/g,'');
    if(digits.length<10 || picked.patient){setDup([]);return;}
    if(phoneMatchRef.current===digits) return;
    const t=setTimeout(async()=>{
      try{
        const[hit,open]=await Promise.all([
          api.crmLookup('patients',digits),
          api.getCrmDuplicates(digits),
        ]);
        const list=Array.isArray(hit?.data)?hit.data:hit?.data?.data||[];
        const match=list.find((x:any)=>{
          const p=(x.phone||'').replace(/\D/g,'');
          return p===digits || p.endsWith(digits.slice(-10));
        });
        if(match && !picked.patient){
          phoneMatchRef.current=digits;
          fillPatient(match);
          notify(`ℹ️ Matched HIS patient ${match.uhid}`);
        }
        const opens=Array.isArray(open?.data)?open.data:open?.data?.data||[];
        setDup(opens);
      }catch{setDup([]);}
    },450);
    return()=>clearTimeout(t);
  },[form.phone,picked.patient]);

  const save=async()=>{
    if(!form.firstName||!form.phone) return notify('❌ Patient name and phone are required');
    setSaving(true);
    try{
      const r=await api.createCrmLead({...form,crmId:form.crmId||undefined,age:form.age||undefined});
      const matched=r?.data?.matchedPatient;
      const opens=r?.data?.openEnquiries||[];
      notify(matched
        ?`✅ Enquiry saved — existing UHID ${matched.uhid}`
        :opens.length
          ?`✅ Enquiry saved — ${opens.length} open enquiry(s) already on this phone`
          :'✅ Enquiry captured');
      setForm({...EMPTY});
      setPicked({});
      setDup([]);
      phoneMatchRef.current='';
      load();
    }catch(ex:any){notify('❌ '+(ex.response?.data?.message||'Could not save enquiry'));}
    setSaving(false);
  };

  const openLead=async(row:any)=>{
    try{
      const r=await api.getCrmLead(row.id);
      setSel(r?.data||row);
      setLostReason('');
    }catch{setSel(row);}
  };

  const logNote=async()=>{
    if(!sel||!note.notes) return notify('❌ Add a call / visit note');
    try{
      await api.addCrmInteraction(sel.id,{type:note.type,notes:note.notes,nextFollowupAt:note.nextFollowupAt||undefined});
      notify('✅ Follow-up logged');
      setNote({type:'CALL',notes:'',nextFollowupAt:''});
      openLead(sel);
      load();
    }catch(ex:any){notify('❌ '+(ex.response?.data?.message||'Could not log'));}
  };

  const setStatus=async(row:any,status:string,reason?:string)=>{
    try{
      await api.updateCrmLead(row.id,{status,lostReason:reason||undefined});
      notify(`✅ Status → ${status.replace(/_/g,' ')}`);
      if(sel?.id===row.id) openLead(row);
      load();
    }catch(ex:any){notify('❌ '+(ex.response?.data?.message||'Could not update status'));}
  };

  const convert=async(row:any)=>{
    try{
      const r=await api.convertCrmLead(row.id);
      const p=r?.data?.patient;
      notify(p?`✅ Linked UHID ${p.uhid}`:'✅ Converted to patient');
      load();
      if(sel?.id===row.id) openLead(row);
      if(p?.id && canRegister) nav(`/patients/edit/${p.id}`);
    }catch(ex:any){notify('❌ '+(ex.response?.data?.message||'Convert failed'));}
  };

  const book=async(row:any)=>{
    if(!canBook) return notify('❌ Appointments module is not assigned to your role');
    try{
      const r=await api.convertCrmLead(row.id);
      const p=r?.data?.patient;
      const lead=r?.data?.lead||row;
      if(p?.id){
        if(lead.status!=='CONVERTED') await api.updateCrmLead(row.id,{status:'APPOINTMENT_BOOKED'}).catch(()=>{});
        const date=(row.preferredDate||row.preferred_date||'').toString().slice(0,10);
        const q=new URLSearchParams({patientId:p.id});
        if(row.doctorId||row.doctor_id) q.set('doctorId',row.doctorId||row.doctor_id);
        if(date) q.set('date',date);
        nav(`/appointments/book?${q.toString()}`);
      } else notify('❌ Convert to patient first');
    }catch(ex:any){notify('❌ '+(ex.response?.data?.message||'Could not open booking'));}
  };

  const markLost=async(row:any)=>{
    const reason=lostReason.trim()||window.prompt('Lost reason (price, went elsewhere, not reachable…)')||'';
    if(!reason) return;
    setLostReason('');
    await setStatus(row,'LOST',reason);
  };

  const cols=[
    {key:'crmId',label:'CRM ID',render:(r:any)=><span className="font-mono text-[#02357A] font-semibold">{crmIdOf(r)}</span>},
    {key:'firstName',label:'Patient',render:(r:any)=><div><p className="font-medium">{name(r)}</p><p className="text-xs text-slate-400">{phoneOf(r)}{r.age?` · ${r.age}y`:''}{r.gender?` · ${r.gender}`:''}</p></div>},
    {key:'enquiryType',label:'Enquiry',render:(r:any)=>r.enquiryType||r.enquiry_type||'—'},
    {key:'department',label:'Dept / Doctor',render:(r:any)=><div><p>{r.department||'—'}</p><p className="text-xs text-slate-400">{r.preferredDoctor||r.preferred_doctor||''}</p></div>},
    {key:'source',label:'Account',render:(r:any)=><div><p>{r.accountType||r.account_type||'INDIVIDUAL'}</p><p className="text-xs text-slate-400">{r.assignedEmployeeName||r.assigned_employee_name||r.source||''}</p></div>},
    {key:'estimatedValue',label:'Value',render:(r:any)=>r.estimatedValue||r.estimated_value?inr(r.estimatedValue||r.estimated_value):'—'},
    {key:'status',label:'Status',render:(r:any)=><span className="text-xs bg-blue-50 text-[#02357A] px-1.5 py-0.5 rounded">{r.status}</span>},
    {key:'nextFollowupAt',label:'Next FU',render:(r:any)=>{
      const d=nextFu(r); if(!d) return '—';
      const late=d<new Date().toISOString().slice(0,10);
      return <span className={late?'text-red-600 font-semibold':''}>{d}</span>;
    }},
    {key:'id',label:'',render:(r:any)=>(
      <div className="flex gap-1 flex-wrap">
        <button type="button" onClick={e=>{e.stopPropagation();openLead(r);}} className="text-xs text-[#02357A] hover:underline">Open</button>
        <button type="button" onClick={e=>{e.stopPropagation();convert(r);}} className="text-xs text-green-700 hover:underline">UHID</button>
        {canBook&&<button type="button" onClick={e=>{e.stopPropagation();book(r);}} className="text-xs text-teal-700 hover:underline">Book</button>}
      </div>
    )},
  ];

  return(
    <Layout title="Enterprise CRM">
      {msg&&<div className={`mb-4 p-3 rounded-lg text-sm border ${msg.startsWith('✅')||msg.startsWith('ℹ️')?'bg-green-50 text-green-700 border-green-200':'bg-red-50 text-red-700 border-red-200'}`}>{msg}</div>}
      <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-8 gap-3 mb-5">
        <StatCard label="Enquiries" value={stats.total||0} icon="📇" color="blue"/>
        <StatCard label="New" value={stats.new_leads||0} icon="🆕" color="amber"/>
        <StatCard label="In progress" value={stats.in_progress||0} icon="📞" color="teal"/>
        <StatCard label="Appointments" value={stats.appointments||0} icon="📅" color="purple"/>
        <StatCard label="Converted" value={stats.converted||0} icon="✅" color="green" sub={stats.converted_value?inr(stats.converted_value):undefined}/>
        <StatCard label="Pipeline" value={inr(stats.pipeline_value)} icon="💰" color="cyan"/>
        <StatCard label="Follow-up today" value={stats.followups_today||0} icon="📌" color="blue"/>
        <StatCard label="Overdue" value={stats.overdue||0} icon="⚠️" color="red"/>
      </div>

      <div className="flex gap-2 mb-4 flex-wrap">
        <button type="button" onClick={()=>setTab('enquiries')} className={`px-4 py-2 rounded-lg text-sm font-medium ${tab==='enquiries'?'bg-[#02357A] text-white':'bg-white border text-slate-600'}`}>Enquiries</button>
        <button type="button" onClick={()=>setTab('pipeline')} className={`px-4 py-2 rounded-lg text-sm font-medium ${tab==='pipeline'?'bg-[#02357A] text-white':'bg-white border text-slate-600'}`}>Pipeline</button>
        <button type="button" onClick={()=>setTab('followups')} className={`px-4 py-2 rounded-lg text-sm font-medium ${tab==='followups'?'bg-[#02357A] text-white':'bg-white border text-slate-600'}`}>Follow-ups ({followups.length})</button>
        <button type="button" onClick={()=>setMine(m=>!m)} className={`px-4 py-2 rounded-lg text-sm font-medium ${mine?'bg-teal-700 text-white':'bg-white border text-slate-600'}`}>My queue</button>
      </div>

      {tab==='followups'?(
        <DataTable loading={loading} data={followups} emptyMessage="No follow-ups due" emptyIcon="📌" searchPlaceholder="Search follow-ups…"
          columns={cols.filter(c=>c.key!=='id').concat([{key:'id',label:'',render:(r:any)=>
            <button type="button" className="text-xs text-[#02357A] hover:underline" onClick={()=>openLead(r)}>Log call</button>}])}
        />
      ):tab==='pipeline'?(
        <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-3 overflow-x-auto">
          {PIPE.map(col=>{
            const rows=leads.filter(l=>col.statuses.includes(l.status));
            const value=rows.reduce((s,r)=>s+Number(r.estimatedValue||r.estimated_value||0),0);
            return(
              <div key={col.key} className="bg-slate-50 rounded-xl border p-2 min-h-[320px]">
                <div className="flex items-center justify-between px-1 mb-2">
                  <p className="text-xs font-bold uppercase text-slate-500">{col.title} · {rows.length}</p>
                  {value>0&&<p className="text-[10px] text-slate-400">{inr(value)}</p>}
                </div>
                <div className="space-y-2">
                  {rows.slice(0,40).map(r=>(
                    <button type="button" key={r.id} onClick={()=>openLead(r)} className="w-full text-left bg-white rounded-lg border p-2.5 hover:border-[#02357A] shadow-sm">
                      <p className="text-sm font-semibold truncate">{name(r)}</p>
                      <p className="text-[11px] text-slate-400 font-mono">{crmIdOf(r)} · {phoneOf(r)}</p>
                      <p className="text-[11px] text-slate-500 truncate">{r.enquiryType||r.enquiry_type} · {r.department||r.preferredDoctor||r.preferred_doctor||'—'}</p>
                      {(r.estimatedValue||r.estimated_value)&&<p className="text-xs text-[#02357A] font-medium mt-1">{inr(r.estimatedValue||r.estimated_value)}</p>}
                    </button>
                  ))}
                  {!loading&&rows.length===0&&<p className="text-xs text-slate-400 p-3">Empty</p>}
                </div>
              </div>
            );
          })}
        </div>
      ):(
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          <div className="card p-5">
            <h3 className="font-bold text-slate-800 mb-1">Capture enquiry</h3>
            <p className="text-xs text-slate-400 mb-3">Search HIS patient, doctor or employee to auto-fill. If nothing is in the system, type it yourself.</p>
            {dup.length>0&&(
              <div className="mb-3 p-2.5 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-800">
                Open enquiry already on this phone:{' '}
                {dup.map((d:any)=>(
                  <button type="button" key={d.id} className="underline font-semibold mr-2" onClick={()=>openLead(d)}>
                    {d.crm_id||d.crmId} ({d.status})
                  </button>
                ))}
              </div>
            )}
            <div className="space-y-3 max-h-[70vh] overflow-y-auto pr-1">
              <div className="flex gap-1 flex-wrap">
                {ACCT.map(a=><button type="button" key={a} onClick={()=>f('accountType',a)} className={`text-[10px] px-2 py-1 rounded-full border ${form.accountType===a?'bg-[#02357A] text-white border-[#015CA6]':'border-slate-300'}`}>{a}</button>)}
              </div>
              <EntityLookup kind="patients" label="Patient (auto-fill from HIS)" placeholder="Search UHID, name, phone…"
                picked={picked.patient}
                onPick={fillPatient}
                onClear={()=>{setPicked(x=>({...x,patient:undefined}));phoneMatchRef.current='';}}
                onFreeText={t=>{
                  if(!picked.patient && t && !form.firstName) {
                    const parts=t.trim().split(/\s+/);
                    f('firstName',parts[0]||''); if(parts[1]) f('lastName',parts.slice(1).join(' '));
                  }
                }}
              />
              <div><label className="label">CRM ID</label><input className="input font-mono" value={form.crmId} onChange={e=>f('crmId',e.target.value.toUpperCase())} placeholder="Auto CRM2026000001"/></div>
              <div className="grid grid-cols-2 gap-2">
                <div><label className="label">First name *</label><input className="input" value={form.firstName} onChange={e=>f('firstName',e.target.value)}/></div>
                <div><label className="label">Last name</label><input className="input" value={form.lastName} onChange={e=>f('lastName',e.target.value)}/></div>
              </div>
              <div className="grid grid-cols-2 gap-2">
                <div><label className="label">Phone *</label><input className="input" type="tel" value={form.phone} onChange={e=>f('phone',e.target.value)}/></div>
                <div><label className="label">Age</label><input className="input" type="number" value={form.age} onChange={e=>f('age',e.target.value)}/></div>
              </div>
              <div><label className="label">Email</label><input className="input" type="email" value={form.email} onChange={e=>f('email',e.target.value)}/></div>
              <div className="grid grid-cols-2 gap-2">
                <div><label className="label">Gender</label>
                  <select className="input" value={form.gender} onChange={e=>f('gender',e.target.value)}><option value="">—</option>{['MALE','FEMALE','OTHER'].map(g=><option key={g}>{g}</option>)}</select>
                </div>
                <div><label className="label">City</label><input className="input" value={form.city} onChange={e=>f('city',e.target.value)}/></div>
              </div>
              <div><label className="label">Address</label><input className="input" value={form.address} onChange={e=>f('address',e.target.value)}/></div>
              <div><label className="label">Enquiry type</label>
                <select className="input" value={form.enquiryType} onChange={e=>f('enquiryType',e.target.value)}>{ENQ.map(s=><option key={s}>{s}</option>)}</select>
              </div>
              <EntityLookup kind="departments" label="Department" placeholder="Search department or type…"
                display={form.department}
                onPick={d=>f('department',d.name||d.department_name||'')}
                onFreeText={t=>f('department',t)}
              />
              <EntityLookup kind="doctors" label="Preferred doctor" placeholder="Search doctor or type if none in roster"
                picked={picked.doctor}
                onPick={d=>{
                  setPicked(x=>({...x,doctor:d}));
                  setForm(s=>({...s,
                    preferredDoctor:`Dr. ${d.first_name||d.firstName||''} ${d.last_name||d.lastName||''}`.trim(),
                    doctorId:d.id,
                    department:s.department||d.specialization||'',
                  }));
                }}
                onClear={()=>{setPicked(x=>({...x,doctor:undefined}));f('doctorId','');f('preferredDoctor','');}}
                onFreeText={t=>!picked.doctor&&f('preferredDoctor',t)}
              />
              <EntityLookup kind="doctors" label="Referring doctor" placeholder="Search in-house doctor or type outside referral"
                picked={picked.referrer}
                onPick={d=>{
                  setPicked(x=>({...x,referrer:d}));
                  f('referringDoctor',`Dr. ${d.first_name||d.firstName||''} ${d.last_name||d.lastName||''}`.trim());
                  f('source','REFERRAL_DOCTOR');
                }}
                onClear={()=>{setPicked(x=>({...x,referrer:undefined}));f('referringDoctor','');}}
                onFreeText={t=>!picked.referrer&&f('referringDoctor',t)}
              />
              <EntityLookup kind="employees" label="Assigned counsellor / employee" placeholder="Search staff or type if HR not loaded"
                picked={picked.employee}
                onPick={d=>{
                  setPicked(x=>({...x,employee:d}));
                  setForm(s=>({...s,assignedTo:d.id,assignedEmployeeName:`${d.first_name||d.firstName||''} ${d.last_name||d.lastName||''}`.trim()}));
                }}
                onClear={()=>{setPicked(x=>({...x,employee:undefined}));f('assignedTo','');f('assignedEmployeeName','');}}
                onFreeText={t=>!picked.employee&&f('assignedEmployeeName',t)}
              />
              {(form.accountType==='CORPORATE'||form.accountType==='INSURANCE')&&(
                <EntityLookup kind="corporate" label="Corporate / TPA" placeholder="Search payer or type company name"
                  picked={picked.corporate}
                  onPick={c=>{setPicked(x=>({...x,corporate:c}));f('corporateName',c.name||c.provider_name||'');f('source','CORPORATE');}}
                  onClear={()=>{setPicked(x=>({...x,corporate:undefined}));f('corporateName','');}}
                  onFreeText={t=>!picked.corporate&&f('corporateName',t)}
                />
              )}
              <div className="grid grid-cols-2 gap-2">
                <div><label className="label">Preferred date</label><input className="input" type="date" value={form.preferredDate} onChange={e=>f('preferredDate',e.target.value)}/></div>
                <div><label className="label">Next follow-up</label><input className="input" type="date" value={form.nextFollowupAt} onChange={e=>f('nextFollowupAt',e.target.value)}/></div>
              </div>
              <div><label className="label">Service / package</label><input className="input" value={form.interestedService} onChange={e=>f('interestedService',e.target.value)} placeholder="Master health check, cataract…"/></div>
              <div className="grid grid-cols-2 gap-2">
                <div><label className="label">Campaign</label><input className="input" value={form.campaign} onChange={e=>f('campaign',e.target.value)} placeholder="World Heart Day camp"/></div>
                <div><label className="label">Est. value (₹)</label><input className="input" value={form.estimatedValue} onChange={e=>f('estimatedValue',e.target.value)}/></div>
              </div>
              <div><label className="label">Source</label>
                <select className="input" value={form.source} onChange={e=>f('source',e.target.value)}>{SRC.map(s=><option key={s}>{s}</option>)}</select>
              </div>
              <div><label className="label">Referring hospital</label><input className="input" value={form.referringHospital} onChange={e=>f('referringHospital',e.target.value)}/></div>
              <div><label className="label">Priority</label>
                <select className="input" value={form.priority} onChange={e=>f('priority',e.target.value)}>{PRI.map(s=><option key={s}>{s}</option>)}</select>
              </div>
              <div><label className="label">Notes</label><textarea className="input" rows={2} value={form.notes} onChange={e=>f('notes',e.target.value)}/></div>
              <button type="button" onClick={save} disabled={saving} className="btn-primary w-full">{saving?'Saving…':'Save enquiry'}</button>
            </div>
          </div>
          <div className="lg:col-span-2">
            <div className="flex gap-2 mb-2 flex-wrap">
              <button type="button" onClick={()=>setStatusFilter('')} className={`text-xs px-3 py-1 rounded-full border ${!statusFilter?'bg-[#02357A] text-white border-[#015CA6]':'border-slate-300'}`}>All</button>
              {ST.map(s=><button type="button" key={s} onClick={()=>setStatusFilter(s)} className={`text-xs px-3 py-1 rounded-full border ${statusFilter===s?'bg-[#02357A] text-white border-[#015CA6]':'border-slate-300 text-slate-600'}`}>{s.replace(/_/g,' ')}</button>)}
            </div>
            <DataTable loading={loading} data={leads} searchPlaceholder="Search CRM ID, name, phone, doctor…" emptyMessage="No hospital enquiries yet" emptyIcon="📇" columns={cols} onRowClick={openLead}/>
          </div>
        </div>
      )}

      <SlidePanel isOpen={!!sel} onClose={()=>setSel(null)} title={sel?`${name(sel)} · ${crmIdOf(sel)||''}`:'Enquiry'} size="lg"
        subtitle={sel?`${sel.enquiryType||sel.enquiry_type||'OPD'} · ${phoneOf(sel)}`:''}
        actions={sel&&(
          <div className="flex gap-2">
            <button type="button" className="btn-secondary" onClick={()=>convert(sel)}>Convert to UHID</button>
            {canBook&&<button type="button" className="btn-primary" onClick={()=>book(sel)}>Book appointment</button>}
          </div>
        )}>
        {sel&&(
          <div className="space-y-4">
            <div className="flex gap-1 flex-wrap">
              {['CONTACTED','FOLLOW_UP','APPOINTMENT_BOOKED','NO_SHOW'].map(s=>(
                <button type="button" key={s} onClick={()=>setStatus(sel,s)} className={`text-[10px] px-2 py-1 rounded-full border ${sel.status===s?'bg-[#02357A] text-white border-[#015CA6]':'border-slate-300'}`}>{s.replace(/_/g,' ')}</button>
              ))}
              <button type="button" onClick={()=>markLost(sel)} className={`text-[10px] px-2 py-1 rounded-full border ${sel.status==='LOST'?'bg-red-600 text-white border-red-600':'border-red-300 text-red-700'}`}>Lost</button>
            </div>
            {sel.status!=='LOST'&&(
              <div className="flex gap-2">
                <input className="input text-xs" placeholder="Lost reason (optional before marking Lost)" value={lostReason} onChange={e=>setLostReason(e.target.value)}/>
              </div>
            )}
            <div className="grid grid-cols-2 gap-2 text-sm">
              {[['Department',sel.department],['Doctor',sel.preferredDoctor||sel.preferred_doctor],['Counsellor',sel.assignedEmployeeName||sel.assigned_employee_name],['Preferred date',(sel.preferredDate||sel.preferred_date||'').toString().slice(0,10)],
                ['Account',sel.accountType||sel.account_type],['Corporate',sel.corporateName||sel.corporate_name],['Campaign',sel.campaign],
                ['Source',sel.source],['Referring doctor',sel.referringDoctor||sel.referring_doctor],['UHID',sel.patient?.uhid||'Not registered'],
                ['Est. value',sel.estimatedValue||sel.estimated_value?inr(sel.estimatedValue||sel.estimated_value):'—'],
                ['Email',sel.email],['Address',sel.address],
                ['Status',sel.status],['Lost reason',sel.lostReason||sel.lost_reason],['Next follow-up',nextFu(sel)]].map(([l,v])=>(
                <div key={String(l)} className="bg-slate-50 rounded-lg p-2"><p className="text-[10px] uppercase text-slate-400">{l}</p><p className="font-medium">{v||'—'}</p></div>
              ))}
            </div>
            <div className="border rounded-lg p-3 space-y-2">
              <p className="font-semibold text-sm">Log call / visit</p>
              <select className="input" value={note.type} onChange={e=>setNote(n=>({...n,type:e.target.value}))}>
                {['CALL','VISIT','WHATSAPP','SMS','NOTE'].map(t=><option key={t}>{t}</option>)}
              </select>
              <textarea className="input" rows={2} placeholder="Spoke to patient, asked to visit tomorrow…" value={note.notes} onChange={e=>setNote(n=>({...n,notes:e.target.value}))}/>
              <div><label className="label">Next follow-up date</label><input className="input" type="date" value={note.nextFollowupAt} onChange={e=>setNote(n=>({...n,nextFollowupAt:e.target.value}))}/></div>
              <button type="button" onClick={logNote} className="btn-primary text-sm">Save interaction</button>
            </div>
            <div>
              <p className="font-semibold text-sm mb-2">History</p>
              <div className="space-y-2 max-h-56 overflow-y-auto">
                {(sel.interactions||[]).length===0&&<p className="text-xs text-slate-400">No interactions yet</p>}
                {(sel.interactions||[]).map((i:any)=>(
                  <div key={i.id} className="text-xs border rounded-lg p-2">
                    <p className="font-semibold text-[#02357A]">{i.interaction_type||i.interactionType} · {(i.created_at||i.createdAt||'').toString().slice(0,16).replace('T',' ')} {i.created_by_name?`· ${i.created_by_name}`:''}</p>
                    <p className="text-slate-600">{i.notes||'—'}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </SlidePanel>
    </Layout>
  );
}
